import { useState } from "react";
import { findParamInLocalStorage } from "../../../utils/getAnyDataLocalStorge";
export var useAddressData = function () {
    var addressData = useState(findParamInLocalStorage("addressData"))[0];
    return { addressData: addressData };
};
